import type { SATUserInterventionArmTaskSubmissionAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryOrderToSQL,
} from './common'
import type { SATUserType } from './constants'
import SATUserQ from './SATUserQ'

const SATUserInterventionArmTaskSubmissionQ = {
  ...makeQueryModelV2<SATUserInterventionArmTaskSubmissionAttributes>(
    'sat_user_intervention_arm_task_submission'
  )([
    'id',
    'sat_user_id',
    'sat_test_intervention_arm_task_id',
    'completed_at',
    'created_at',
    'deleted_at',
    'updated_at',
  ]),

  associations: (): AssociationDefinitions => ({
    SATUser: {
      query: SATUserQ,
      foreignKey: SATUserQ.id,
      sourceKey: SATUserInterventionArmTaskSubmissionQ.sat_user_id,
    },
  }),

  where: (
    {
      id = null,
      satUserId,
      satTestInterventionArmTaskId,
      include = [],
      paranoid = true,
      order = null,
    }: {
      id?: number | null | SQLFragment<number>
      satUserId?: number | null | SQLFragment<number>
      satTestInterventionArmTaskId?: number | null | SQLFragment<number>
      include?: IncludeAssociations
      paranoid?: boolean
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SATUserInterventionArmTaskSubmissionAttributes> => SQL`
        FROM ${SATUserInterventionArmTaskSubmissionQ}
        ${includeAssociationsToSql(SATUserInterventionArmTaskSubmissionQ, include)}
        WHERE
            ${id != null ? SQL`${SATUserInterventionArmTaskSubmissionQ.id} = ${id} AND` : SQL``}
            ${
              satUserId != null
                ? SQL`${SATUserInterventionArmTaskSubmissionQ.sat_user_id} = ${satUserId} AND`
                : SQL``
            }
            ${
              satTestInterventionArmTaskId != null
                ? SQL`${SATUserInterventionArmTaskSubmissionQ.sat_test_intervention_arm_task_id} = ${satTestInterventionArmTaskId} AND`
                : SQL``
            }
            ${
              paranoid
                ? SQL`${SATUserInterventionArmTaskSubmissionQ.deleted_at} IS NULL AND`
                : SQL``
            }
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryOrderToSQL(order)}
    `,

  getTaskSubmissionsForUser: ({
    userId,
    satUserType,
  }: {
    userId: number
    satUserType: SATUserType
  }): SQLFragment<SATUserInterventionArmTaskSubmissionAttributes> =>
    SATUserInterventionArmTaskSubmissionQ.where({
      include: [
        {
          association: 'SATUser',
          required: true,
          where: SQL`(${SATUserQ.user_id} = ${userId} AND ${SATUserQ.type} = ${satUserType})`,
        },
      ],
    }),
}

export default SATUserInterventionArmTaskSubmissionQ
